import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeComponent } from './tree.component';
import { RouterModule } from '@angular/router';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { NodeComponent } from './node/node.component';



@NgModule({
  declarations: [
    TreeComponent,
    NodeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TreeViewModule,
    TooltipModule
    
    ],
  exports:[TreeComponent]
})
export class TreeModule { }
